/**
 * Default notion of the subtree validity. This validity is just tho validity of the node itself.
 * @param {Object} node
 * @returns {Boolean}
 */
function defaultValidity(node) {
    return node.aspects.valid;
}

/**
 * Notion of the validity for the array node.
 * @param {Object} node
 * @returns {boolean}
 */
function arrayValidity(node) {
    if (!node.aspects.valid) {
        return false;
    }
    var len = node.length;
    for (var i = 0; i < len; i++) {
        if (!node.getElement(i).aspects.subtreeValid) {
            return false;
        }
    }
    return true;
}

/**
 * Returns a validity function for the dto.
 * @param {Object} info
 * @returns {function}
 */
function getDtoValidityFunction(info) {
    return function (node) {
        if (!node.aspects.valid) {
            return false;
        }

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = info.properties[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var prop = _step.value;

                if (node[prop.jsProperty] && !node[prop.jsProperty].aspects.subtreeValid) {
                    return false;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        return true;
    };
}

/**
 * Returns a function to extract validity from the metadata node.
 * @param {Object} metadata
 * @returns {Function}
 */
function getValidityFn(metadata) {
    if (metadata.readOnly) {
        return function () {
            return true;
        };
    }
    switch (metadata.valueType.kind) {
        case 'class':
            var typeInfo = metadata.valueType.typeInfo;
            if (typeInfo.metaType.isDto) {
                return getDtoValidityFunction(typeInfo);
            }
            return defaultValidity;
        case 'collection':
            return arrayValidity;
        default:
            return defaultValidity;
    }
}

/* Aspect defining validity of the whole model subtree. */
var alwaysValid = function alwaysValid() {
    return true;
};
export default {
    'getAspectProperties': function getAspectProperties(currentViewModelNode, currentMetadataNode, ancestorChain, config) {
        var consideredValid = config && config.subtreeValidity && config.subtreeValidity.assumeValid ? config.subtreeValidity.assumeValid : null;

        var accessor = consideredValid && consideredValid.includes(currentMetadataNode.valueType.name) ? alwaysValid : getValidityFn(currentMetadataNode);

        return {
            'subtreeValid': {
                'get': function get() {
                    return accessor(currentViewModelNode);
                }
            }
        };
    }
};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/api/gw-portals-viewmodel-js/aspects/SubtreeValidity.js
// module id = 942
// module chunks = 0